import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Grid2 from "@mui/material/Unstable_Grid2";
import { NavLink } from "react-router-dom";
import Icon from "@mui/material/Icon";

let roundedLeft = {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.12)",
};

let activeScanStyle = {
    ...roundedLeft,
    backgroundColor: "#17C5C7",
};

let inActiveScanStyle = {
    ...roundedLeft,
    backgroundColor: "white",
};

let roundedRight = {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.12)",
};

let activeInputStyle = {
    ...roundedRight,
    backgroundColor: "#17C5C7",
};

let inActiveInputStyle = {
    ...roundedRight,
    backgroundColor: "white",
};

function NavigationToggle() {
    return (
        <div className="navigation">
            <Grid2
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                }}
            >
                <nav>
                    <ToggleButtonGroup
                        color="primary"
                        exclusive
                        aria-label="input mode toggle"
                        style={{
                            padding: 0,
                        }}
                    >
                        <NavLink
                            to={"/scan"}
                            style={({ isActive }) =>
                                isActive ? activeScanStyle : inActiveScanStyle
                            }
                        >
                            <ToggleButton
                                value="scan"
                                style={{
                                    ...roundedLeft,
                                    backgroundColor: "transparent",
                                }}
                            >
                                <Icon
                                    style={{
                                        textAlign: "center",
                                        lineHeight: 1,
                                        width: "28px",
                                    }}
                                >
                                    <img
                                        src="barcode-icon.svg"
                                        alt="Barcode icon"
                                        style={{
                                            height: "100%",
                                        }}
                                    />
                                </Icon>
                            </ToggleButton>
                        </NavLink>
                        <NavLink
                            to={"/input"}
                            style={({ isActive }) =>
                                isActive ? activeInputStyle : inActiveInputStyle
                            }
                        >
                            <ToggleButton
                                value="input"
                                style={{
                                    ...roundedRight,
                                    backgroundColor: "transparent",
                                }}
                            >
                                <DriveFileRenameOutlineIcon />
                            </ToggleButton>
                        </NavLink>
                    </ToggleButtonGroup>
                </nav>
            </Grid2>
        </div>
    );
}

export default NavigationToggle;
